import '../../../../icons'
import platformRedirect from '../../../../mixins/platformRedirect'
import VueNotifications from 'vue-notifications'

export default {
  name: 'FacebookSimple',
  mixins: [platformRedirect],
  notifications: {
    showErrorMsg: {
      type: VueNotifications.types.warn
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    }
  },
  created () {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '1574453629311410',
        cookie: true,
        xfbml: true,
        version: 'v2.8'
      })
    };

    // Load the SDK asynchronously
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s)
      js.id = id
      js.src = 'https://connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  },
  methods: {
    emitValues (fbUser) {
      this.$emit('user', fbUser)
    },
    haveKey (object, key) {
      return object ? hasOwnProperty.call(object, key) : false
    },
    facebookLogin () {
      FB.login((response) => {
        let url = 'user/login/social/facebook/' + response.authResponse.accessToken
        this.$http.post(url).then((response) => {
          if (this.haveKey(response.body, 'token')) {
            return this.setTokenAndRedirect(response.body.token)
          }

          if (response.body.is_user) {
            return this.showErrorMsg({
              title: this.$i18n.t('Your account is not verified'),
              message: this.$i18n.t(response.body.message)
            })
          }

          this.showInfoMsg({
            title: this.$i18n.t('Your facebook account dont have the fields needed'),
            message: this.$i18n.t('The sign up form is filled with your facebook profile data.')
          })

          this.emitValues(response.body.options)
        })
      }, { scope: 'email,public_profile' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/buttons/facebookSimple/facebookSimple.js